// AoT requires an exported function for factories
import { LOCATION_INITIALIZED, registerLocaleData } from '@angular/common';
import localeFrExtra from '@angular/common/locales/extra/fr';
import localeFr from '@angular/common/locales/fr';
import { Injectable, InjectionToken, Injector } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { defaultIfEmpty, forkJoin, lastValueFrom } from 'rxjs';

export interface ModuleOptions {
  langs?: string[];
}

@Injectable({
  providedIn: 'root'
})
export class I18nOptions {
  public langs: string[] = [];
}

export const FOR_ROOT_OPTIONS_TOKEN = new InjectionToken<ModuleOptions>('forRoot() I18n configuration.');

export function provideI18nOptions(options?: ModuleOptions): I18nOptions {
  const i18nOptions = new I18nOptions();
  if (options) {
    if (Array.isArray(options.langs)) {
      i18nOptions.langs = options.langs;
    }
  }
  return i18nOptions;
}

// Same registrations the former side-effect import `@angular/common/locales/global/fr` did ('fr'), plus 'fr-FR'.
registerLocaleData(localeFr, 'fr', localeFrExtra);
registerLocaleData(localeFr, 'fr-FR', localeFrExtra);

export function TranslateInitializerFactory(translateService: TranslateService, injector: Injector) {
  return async () => {
    await injector.get(LOCATION_INITIALIZED, Promise.resolve(null));
    const options: I18nOptions = injector.get(I18nOptions);
    const languages = options.langs && !!options.langs.length ? [...options.langs] : ['en'];
    const defaultLang = 'en';

    translateService.addLangs(languages);

    // Wait for all translations to be loaded
    await lastValueFrom(forkJoin(languages.filter((l: string) => l !== defaultLang).map((l: string) => translateService.use(l))));

    // Set default (fallback) language — @ngx-translate 18: setDefaultLang() → setFallbackLang(), currentLang is a read-only signal
    await lastValueFrom(translateService.setFallbackLang(defaultLang));
    await lastValueFrom(translateService.use(defaultLang));
  };
}
